import { LegalPageLayout } from "./LegalPageLayout";

export default function Terms() {
  return (
    <LegalPageLayout title="Conditions Générales d'Utilisation">
      <p><em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</em></p>

      <h2>1. Objet</h2>
      <p>
        Les présentes CGU régissent l'utilisation de la plateforme Libaddict, 
        service de mise en relation entre patients et professionnels de santé 
        spécialisés dans les addictions.
      </p>

      <h2>2. Inscription</h2>
      <h3>2.1 Conditions</h3>
      <ul>
        <li>Être majeur ou disposer d'une autorisation parentale</li>
        <li>Fournir des informations exactes lors de la création du compte</li>
        <li>Accepter les présentes CGU</li>
      </ul>

      <h3>2.2 Compte professionnel</h3>
      <p>
        Les praticiens doivent fournir des justificatifs de leur qualification 
        (numéro RPPS/Adeli, documents professionnels, spécialité médicale) 
        et respecter leur code de déontologie.
      </p>

      <h2>3. Utilisation du service</h2>
      <h3>3.1 Engagements des utilisateurs</h3>
      <ul>
        <li>Utiliser le service de bonne foi</li>
        <li>Respecter la confidentialité des échanges</li>
        <li>Ne pas partager ses identifiants</li>
        <li>Signaler tout abus à l'équipe Libaddict</li>
      </ul>

      <h3>3.2 Interdictions</h3>
      <ul>
        <li>Usurpation d'identité</li>
        <li>Harcèlement, propos discriminatoires ou haineux</li>
        <li>Diffusion de contenu illégal, médicalement dangereux ou diffamatoire</li>
        <li>Tentative de piratage, d'accès non autorisé ou d'exploitation de failles</li>
      </ul>

      <h2>4. Rendez-vous</h2>
      <p>
        Les rendez-vous sont pris via la plateforme. En cas d'annulation, 
        les utilisateurs doivent prévenir au moins 24h à l'avance. 
        Libaddict ne perçoit aucune commission sur les paiements éventuels 
        entre praticiens et patients.
      </p>

      <h2>5. Responsabilité</h2>
      <p>
        Libaddict agit comme intermédiaire. Le site ne fournit aucun conseil 
        médical et ne saurait être tenu responsable des contenus ou consultations 
        réalisées par les praticiens référencés. Chaque professionnel reste seul 
        responsable des actes, informations ou recommandations qu'il émet.
      </p>

      <h2>6. Résiliation</h2>
      <p>
        Les utilisateurs peuvent supprimer leur compte à tout moment. 
        Libaddict se réserve le droit de suspendre ou résilier un compte 
        en cas de non-respect des présentes CGU ou d'utilisation abusive du service.
      </p>

      <h2>7. Modification des CGU</h2>
      <p>
        Libaddict peut modifier les présentes CGU à tout moment. 
        Les utilisateurs seront informés par e-mail ou notification sur le site.
      </p>

      <h2>8. Droit applicable</h2>
      <p>
        Les présentes CGU sont soumises au droit français. 
        Tout litige sera soumis à la juridiction compétente de Paris (France).
      </p>
    </LegalPageLayout>
  );
}
